import { Link } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

export default function GuestHeader() {
  const { isDark, toggleTheme } = useTheme();
  return (
    <header className="dq-header">
      <div className="dq-header-inner">
        <Link to="/" className="dq-brand" aria-label="Disqover home">
          <img src={`/brand/disqover-wordmark-${isDark ? 'light' : 'dark'}.png`}
            width={isDark ? 584 : 701} height={isDark ? 137 : 166}
            alt="Disqover" data-testid="app-logo" />
        </Link>
        <button type="button" className="dq-icon-button" onClick={toggleTheme}
          aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
          aria-pressed={isDark} data-testid="theme-toggle">
          {isDark ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
        </button>
      </div>
    </header>
  );
}
